import * as stylex from '@stylexjs/stylex';

const styles = stylex.create({
    metadataIcon: {
        opacity: 0.7,
        fontSize: '0.85rem',
    },
});

export const GenreIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" {...stylex.props(styles.metadataIcon)}>
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
    </svg>
);

export const YearIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" {...stylex.props(styles.metadataIcon)}>
        <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" />
    </svg>
);

export const DurationIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" {...stylex.props(styles.metadataIcon)}>
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>
);

export const VolumeIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" {...stylex.props(styles.metadataIcon)}>
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
    </svg>
); 